import { Button, Spinner, Tooltip } from '@ds';
import { RelativeGeneratedTime } from './RelativeGeneratedTime';
import { useSuggestedRouteValidationContext } from './SuggestedRouteValidationContext';

type RouteItemActionButtonsProps = {
  isDataLoading: boolean;
  isApplyLoading: boolean;
  generatedDateTimeMs: number | null;
  generateRoutes: () => Promise<void>;
  handleApplyRoute: () => void;
};

const renderErrorMessages = (errorMessages: string[]) => {
  return errorMessages.length ? (
    <div className="flex flex-col gap-1">
      {errorMessages.map((e) => (
        <span key={e}>{e}</span>
      ))}
    </div>
  ) : null;
};

export const RouteItemActionButtons = ({
  isDataLoading,
  isApplyLoading,
  generatedDateTimeMs,
  generateRoutes,
  handleApplyRoute,
}: RouteItemActionButtonsProps) => {
  const { isValidRoute, isRegenerateAllowed, regenerateErrorMessages, errorMessages } =
    useSuggestedRouteValidationContext();

  return (
    <div className="flex items-center gap-4">
      {!!generatedDateTimeMs &&
        (isDataLoading ? (
          <div className="flex gap-2 items-center">
            <span className="text-xs-sb text-base-20">Generating...</span>
            <Spinner size="sm" />
          </div>
        ) : (
          <RelativeGeneratedTime generatedDateTimeMs={generatedDateTimeMs} />
        ))}
      <Tooltip
        className="text-sm text-base-5"
        isDisabled={!regenerateErrorMessages.length}
        placement="left"
        showArrow
        content={renderErrorMessages(regenerateErrorMessages)}
      >
        <div>
          <Button
            size="sm"
            variant="outline"
            isDisabled={isApplyLoading || isDataLoading || !isRegenerateAllowed}
            onPress={generateRoutes}
          >
            Regenerate
          </Button>
        </div>
      </Tooltip>
      <Tooltip
        className="text-sm text-base-5"
        isDisabled={!errorMessages.length}
        placement="left"
        showArrow
        content={renderErrorMessages(errorMessages)}
      >
        <div className="ml-auto my-auto">
          <Button size="sm" isLoading={isApplyLoading} isDisabled={!isValidRoute} onPress={handleApplyRoute}>
            Apply Route
          </Button>
        </div>
      </Tooltip>
    </div>
  );
};
